import { BrowserRouter, Route, Routes } from "react-router-dom";

import SearchPage from "./routes/search_page/SearchPage";
import FavoritePage from "./routes/favorite_page/FavoritePage";
import Header from "./components/header/Header";
import LoadOverlayProvider from "./contexts/load_overlay/LoadOverlayProvider";
import ItemPage from "./routes/item_page/ItemPage";
import AuctionHouseProvider from "./contexts/AuctionHouseProvider";

function App(): JSX.Element {
    return (
        <BrowserRouter>
            <AuctionHouseProvider>
                <Header></Header>
                <LoadOverlayProvider>
                    <main>
                        <Routes>
                            <Route path="/" element={<SearchPage />} />
                            <Route path="/search/:term" element={<SearchPage />} />
                            <Route path="/item/:itemid" element={<ItemPage />} />
                            <Route path="/favs" element={<FavoritePage />} />
                            <Route path="*" element={<>404: Not Found</>} />
                        </Routes>
                    </main>
                </LoadOverlayProvider>
            </AuctionHouseProvider>
        </BrowserRouter>
    );
}

export default App;
